import { styled } from '@mui/material';

import { Button } from '../Button';
import { resolveFooterButtonTestId } from '../footerButtonTestId';
import { Tooltip } from '../Tooltip';
import { usePageFooterContext } from './PageFooterContext';
import { pageFooterClasses } from './theme';

import type { PageFooterButtonProps } from './types';

const PageFooterButton = (props: PageFooterButtonProps) => {
  const {
    children,
    'data-testid': dataTestId,
    disabled: disabledProp,
    disabledTooltip,
    eventType,
    variant,
    ...otherButtonProps
  } = props;
  const { message = '', ...otherTooltipProps } = disabledTooltip || {};
  const { variantMap, labelMap, loading } = usePageFooterContext();

  const disabled = disabledProp || loading;
  const label = eventType ? labelMap[eventType] : undefined;

  return (
    <Tooltip message={!disabled ? '' : message} {...otherTooltipProps}>
      <span>
        <PageFooterButtonBase
          variant={eventType && variantMap[eventType] ? variantMap[eventType] : variant}
          disabled={disabled}
          size="lg"
          data-testid={dataTestId ?? resolveFooterButtonTestId(eventType)}
          {...otherButtonProps}
        >
          {typeof label === 'function' ? label() : (label ?? children)}
        </PageFooterButtonBase>
      </span>
    </Tooltip>
  );
};

export default PageFooterButton;

const PageFooterButtonBase = styled(Button, {
  target: pageFooterClasses.button,
})``;
